import { Component, OnInit } from '@angular/core';
import { EventType } from './shared/event-type.model';
import { EventTypeService } from '../shared/event-type/event-type.service';
import { UtilService } from '../../shared/util/util.service';
import { NotificationService } from '../../shared/notification/notification.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { DialogService, DatagridService } from '../../shared/index';
import { AsyncState } from '../../shared/model/index';
import { ProfileRead } from '../../profiles/shared/profile-read.model';
import { EventsService } from '../shared/events.service';
import { EventSearchParams } from '../search/event-search-params.model';
import { EventEdit } from '../shared/event-edit.model';

@Component({
  selector: 'wl-event-type-edit',
  templateUrl: 'event-type-edit.component.html',
  styleUrls: ['event-type-edit.component.css'],
  providers: [EventsService],
    standalone: false
})
export class EventTypeEditComponent implements OnInit {
  public _utilService: UtilService;
  public _eventTypeService: EventTypeService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _dataGridService: DatagridService;
  public _eventTypeToDelete: string;
  public _eventsService: EventsService;

  public isSearching: boolean;
  public loadingEventType: AsyncState;

  public findingEvents: boolean;
  public anyEvents: boolean;
  public events: Array<EventEdit>;
  public eventTypeToMigrateTo: string;

  public saving: boolean;
  public savingError: string;

  public editing: boolean;

  public loadingEventTypes: boolean;
  public loadingEventTypesError: string;

  public deleting: boolean;
  public deleteError: string;

  public selectedEventType: EventType;

  public eventType: EventType;
  public eventTypes: Array<EventType>;

  public searchResult: any;
  public searchParams: any;

  public showEventTypeModal = false;
  public showDeleteModal = false;

  public constructor(
    utilService: UtilService,
    eventTypeService: EventTypeService,
    notifyService: NotificationService,
    translationService: TranslationService,
    dataGridService: DatagridService,
    eventsService: EventsService
  ) {
    this._eventTypeService = eventTypeService;
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._dataGridService = dataGridService;
    this._eventsService = eventsService;
    this._eventTypeToDelete = '';

    this.loadingEventTypes = false;
    this.loadingEventTypesError = '';

    this.eventTypeToMigrateTo = 'None';

    this.isSearching = false;

    this.findingEvents = false;
    this.anyEvents = false;
    this.events = new Array<EventEdit>();

    this.eventType = new EventType();
    this.eventTypes = new Array<EventType>();

    this.editing = false;

    this.deleting = false;
    this.deleteError = '';

    this.searchResult = {};

    this.loadingEventType = new AsyncState();

    this.saving = false;
    this.savingError = '';
    this.selectedEventType = new EventType();

    this.searchParams = { Keyword: '', PageSize: 10, OrderBy: 'EventType1' };
  }

  ngOnInit() {}

  public lazyLoadEventTypes = ($event: any): void => {
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    this.loadEventTypes(this.searchParams);
  };

  public newEventType = (): void => {
    this.saving = false;
    this.savingError = '';

    this.loadingEventType.busy = false;
    this.loadingEventType.message = '';

    let newEventType: EventType = new EventType();
    this.selectedEventType = newEventType;
    this.showEventTypeModal = true;
  };

  public loadEventTypes(searchParams: any) {
    this.loadingEventTypes = true;
    this.loadingEventTypesError = '';

    this._eventTypeService
      .searchEventTypes(searchParams)
      .then((data: any) => {
        this.loadingEventTypes = false;
        this.eventTypes = data.Result;
        this.searchResult = data;
        if (this.eventTypes.length > 0) {
          this.selectedEventType = this.eventTypes[0];
        }
      })
      .catch((error) => {
        this.loadingEventTypes = false;
        this.loadingEventTypesError = this._utilService.extractErrorMessage(error);
      });
  }

  public getAllButOneEventType() {
    return this.eventTypes.filter((v, i, a) => v.EventType != this._eventTypeToDelete);
  }

  public saveEventTypes = (): void => {
    this.saving = true;
    this.savingError = '';

    this._eventTypeService
      .upsertEventType(this.selectedEventType)
      .then(() => {
        this.saving = false;

        this.loadEventTypes(this.searchParams);
        this.showEventTypeModal = false;

        this._translationService.get('common.success').then((translation) => this._notifyService.success(translation));
      })
      .catch((error) => {
        this.saving = false;
        this.savingError = this._utilService.extractErrorMessage(error);
      });
  };

  public editEventType = (type: string): void => {
    this.saving = false;
    this.savingError = '';

    this.editing = true;

    this.loadingEventType.busy = true;
    this.loadingEventType.message = '';
    this.loadingEventType.success = false;

    this.showEventTypeModal = true;
    this._eventTypeService
      .getEventType(type)
      .then((data) => {
        this.loadingEventType.busy = false;
        this.loadingEventType.success = true;
        this.selectedEventType = data;
      })
      .catch((error) => {
        this.loadingEventType.busy = false;
        this.loadingEventType.message = this._utilService.extractErrorMessage(error);
        this.loadingEventType.success = false;
      });
  };

  public confirmDeleteEventType(type: string): void {
    this.deleting = false;
    this.deleteError = '';
    this._eventTypeToDelete = type;
    let searchParams = new EventSearchParams();
    searchParams.PageSize = 1;
    searchParams.PageNumber = 1;
    searchParams.EventType = type;
    searchParams.SearchDateEnd = new Date(2100, 1);
    this.findingEvents = true;
    this.showDeleteModal = true;
    this._eventsService.searchEvents(searchParams).then((data: any) => {
      this.findingEvents = false;
      this.events = data.Result;
      if (data.Result.length > 0) {
        this.anyEvents = true;
      } else {
        this.anyEvents = false;
      }
    });
  }

  public deleteEventType = (): void => {
    this.deleting = true;
    this.deleteError = '';

    this._eventTypeService
      .deleteEventType(this._eventTypeToDelete, '')
      .then(() => {
        this.deleting = false;
        this.showDeleteModal = false;
        this.loadEventTypes(this.searchParams);
      })
      .catch((error) => {
        this.deleting = false;
        this.deleteError = this._utilService.extractErrorMessage(error);
      });
  };

  public deleteMigrateEventType = (): void => {
    this.deleting = true;
    this.deleteError = '';
    if (this.eventTypeToMigrateTo == 'None') {
      this.eventTypeToMigrateTo = '';
    }
    this._eventTypeService
      .deleteEventType(this._eventTypeToDelete, this.eventTypeToMigrateTo)
      .then(() => {
        this.deleting = false;
        this.showDeleteModal = false;
        this.loadEventTypes(this.searchParams);
      })
      .catch((error) => {
        this.deleting = false;
        this.deleteError = this._utilService.extractErrorMessage(error);
      });
  };

  public isEventTypeEmpty = (): boolean => {
    return this.selectedEventType.EventType.trim() == '';
  };
}
